// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React from 'react';
import { useLocalize } from '@ta/platform.i18n';
import styles from './SkipButton.css';

type Props = {|
  disabled: boolean,
  onClick: () => mixed,
|};

/**
 * A button to navigate to the previous step of an onboarding flow
 */
const SkipButton = ({ disabled, onClick }: Props) => {
  const { localize } = useLocalize();
  return (
    <button className={styles.skipButton} onClick={onClick} disabled={disabled}>
      {localize('explicit_preferences_who_are_you_traveling_with_skip_button') /* SKIP */}
    </button>
  );
};

export default SkipButton;
